import { useCallback, useRef, useState } from "react";
import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import type { BuildingFormInput } from "web_myplann/Portfolio/Forms/BuildingShared/buildingFormSchema";
import type { FlatFormInput } from "web_myplann/Portfolio/Forms/FlatForm/flatFormSchema";
import {
	type BuildingRealEstateType,
	DEFAULT_REAL_ESTATE_TYPE,
	type RealEstateType,
} from "web_myplann/Portfolio/Forms/RealEstateForm/realEstateTypes";

type BuildingDrafts = {
	[ClientPropertyTypeEnum.Flat]?: FlatFormInput;
	[ClientPropertyTypeEnum.House]?: BuildingFormInput;
	[ClientPropertyTypeEnum.Cottage]?: BuildingFormInput;
};

export const useBuildingDraftForm = () => {
	const [type, setType] = useState<RealEstateType>(DEFAULT_REAL_ESTATE_TYPE);

	const drafts = useRef<BuildingDrafts>({});
	const snapshotRef = useRef<(() => FlatFormInput | BuildingFormInput) | null>(
		null,
	);

	const registerSnapshot = useCallback(
		(getValues: () => FlatFormInput | BuildingFormInput) => {
			snapshotRef.current = getValues;
		},
		[],
	);

	const getDraft = useCallback(
		<T extends BuildingRealEstateType>(buildingType: T): BuildingDrafts[T] =>
			drafts.current[buildingType],
		[],
	);

	const onTypeChange = (nextType: RealEstateType) => {
		if (type !== ClientPropertyTypeEnum.Land && snapshotRef.current) {
			drafts.current[type] =
				snapshotRef.current() as BuildingDrafts[typeof type];
		}

		snapshotRef.current = null;
		setType(nextType);
	};

	return { type, onTypeChange, registerSnapshot, getDraft };
};
